import { identity } from "@core/foundation/function";
import {
  createModel,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

const BarcodeProductSourceSchema = z.enum(["open-food-facts"]);

export const BarcodeProduct = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item) };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        barcode: z.alphaNumeric(),
        brand: z.string().nullable(),
        name: z.string().nullable(),
        raw: z.string().nullable(),
        source: BarcodeProductSourceSchema.nullable(),
        totalCalories: z.number().nonnegative().nullable(),
        weightGrams: z.number().positive().nullable(),
      },
      {
        barcode: "The product's barcode.",
        brand: "The product's brand, or null when the source names none.",
        name: "The product's name, or null when the source names none.",
        raw: "The source's answer as received, or null when none was kept.",
        source: "The database the product was looked up in, or null.",
        totalCalories: "The product's total kcal, or null when unknown.",
        weightGrams: "The product's weight in grams, or null when unknown.",
      },
    ),
    derive: { create: identity, recovery: identity, update: noModelUpdate },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface BarcodeProduct extends z.infer<typeof BarcodeProduct.schema> {}
